const parentsSelectorList = [
  ".scroll-spy__item",
  ".faq__item",
  ".linklist__item",
  ".item-card",
];

function existenceChecker() {
  let elements = [];
  allProducts.forEach((prod) => {
    for (let i = 0; i < parentsSelectorList.length; i++) {
      $(`${parentsSelectorList[i]}:contains(${prod.title})`).each(function () {
        elements.push($(this));
      });
    }
  });

  elements.forEach((el) => {
    for (let i = 0; i < customerProducts.length; i++) {
      const prodTitle = customerProducts[i].title;
      const elText = $(el).text();
      const matchingString = elText.match(prodTitle) || null;

      console.log(matchingString)
      if (matchingString) {
        
        if (matchingString[0].includes(prodTitle)) {
          $(el).show();
          break;
        } else {
          console.log($(el))
          $(el).hide();
        }
      }else{
        $(el).hide();
      }
    }
  });
}

existenceChecker();
